import { fetchApiData } from './ApiCalls';
import { GET_ROSETTA_DATA } from '../urls';

/** Scopes with no elements aren't selectable on intake / fill-on-behalf / catalog UI. */
export const scopeHasSelectableElements = scope =>
  Array.isArray(scope?.elements) && scope.elements.length > 0;

/**
 * Staff and public forms both load the non-legacy Rosetta catalog.
 * Pass `open: true` for the unauthenticated customer scope form.
 */
export const fetchScopeCatalog = async ({ signal, open = false } = {}) =>
  fetchApiData({
    endpoint: GET_ROSETTA_DATA,
    apiRequest: 'GET',
    params: { is_legacy: 'false' },
    signal,
    open
  });

/** Nested trades > sections > scopes, dropping empty scopes/sections/trades. */
export const filterSelectableCatalogTrades = trades =>
  (trades || [])
    .map(t => ({
      ...t,
      sections: (t.sections || [])
        .map(sec => ({
          ...sec,
          scopes: (sec.scopes || []).filter(scopeHasSelectableElements)
        }))
        .filter(sec => (sec.scopes || []).length > 0)
    }))
    .filter(t => (t.sections || []).length > 0);

/**
 * Flatten trades > sections > scopes into trade.scopes[] with section_* stamped.
 * Used by the customer scope form intake UI.
 */
export const normalizeCatalog = payload => {
  const trades = (payload?.trades || [])
    .map(trade => {
      const scopes = [];
      (trade.sections || []).forEach(section => {
        const sectionScopes = (section.scopes || []).filter(scopeHasSelectableElements);
        if (!sectionScopes.length) return;
        sectionScopes.forEach(scope => {
          scopes.push({
            ...scope,
            section_id: section.section_id,
            section_name: section.section_name
          });
        });
      });
      return { ...trade, scopes };
    })
    .filter(trade => trade.scopes.length > 0);
  return { ...payload, trades };
};
